import data from "../data/webTechnology.json";

const cssQuiz = data.css;
const htmlQuiz = data.html;
const javascriptQuiz = data.javascript;
const reactQuiz = data.react;
const jqueryQuiz = data.jquery;
const bootstrapQuiz = data.bootstrap;
const sassQuiz = data.sass;
const lessQuiz = data.less;
const nodeJsQuiz = data.nodejs
const expressJsQuiz = data.expressjs;
const angularQuiz = data.angular;
const vueQuiz = data.vue;
const jsonQuiz = data.json;
const httpQuiz = data.http;
const dHtmlQuiz = data.dhtml;
const typescriptQuiz = data.typescript;
const reactNativeQuiz = data["react-native"];


export {cssQuiz, htmlQuiz, javascriptQuiz, reactQuiz, jqueryQuiz, bootstrapQuiz, sassQuiz, lessQuiz, nodeJsQuiz, expressJsQuiz
    ,angularQuiz, vueQuiz, jsonQuiz, httpQuiz, dHtmlQuiz, typescriptQuiz, reactNativeQuiz
};